import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Sketch from '../views/Sketch.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'sketch',
    component: Sketch
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
